import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime: 0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getInvoice = createAsyncThunk(
  "admin/invoice",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/admin/invoice", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getInvoiceById = createAsyncThunk(
  "admin/invoice/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/admin/invoice/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortInvoice = createAsyncThunk(
  "admin/invoice/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/admin/invoice/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postInvoice = createAsyncThunk(
  "admin/invoice/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/admin/invoice", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteInvoice = createAsyncThunk(
  "admin/invoice/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/admin/invoice/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateInvoice = createAsyncThunk(
  "admin/invoice/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/admin/invoice/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);


const invoiceSlice = createSlice({
  name: "Invoice Store",
  initialState: initialState,
  reducers: {
    addInvoice(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortInvoice(state, action) {
      state.data.docs = action.payload;
    },
    deleteInvoice(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editInvoice(state, action) {
      let x = state.data.docs.findIndex((item) => item._id === action.payload._id);
      state.data.docs[x] = action.payload;
    },
  },
  extraReducers: {
    [getInvoice.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getInvoice.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getInvoice.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getInvoiceById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getInvoiceById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getInvoiceById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortInvoice.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortInvoice.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortInvoice.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postInvoice.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postInvoice.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postInvoice.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteInvoice.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteInvoice.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteInvoice.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateInvoice.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateInvoice.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateInvoice.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const invoiceActions = invoiceSlice.actions;

export default invoiceSlice.reducer;
